import React, { Component, Fragment} from 'react';
import ReactDOM from 'react-dom';
import { Redirect, Route, Switch, withRouter/*, matchPath*/ } from 'react-router-dom';
import { AppAside, AppFooter, AppHeader, AppSidebar, /*AppBreadcrumb,*/ AppSidebarFooter, AppSidebarForm, AppSidebarHeader, AppSidebarMinimizer } from '@coreui/react';
import { socketInitialization, forceRenewPubnubToken,socketteInit, logout } from '../../store/actions/userActions';
import { handleNewMessages, messageActions } from '../../store/actions/chatActions.js';
//import {GeneralErrors} from '../../views/Errors/GeneralErrors';
import { Alert } from 'reactstrap';
import { connect } from 'react-redux';
// sidebar nav config
import highAdminNavigationEs from '../../_navOwner_es';
import highAdminNavigationEn from '../../_navOwner_en';
import superAdminNavigationEs from '../../_navSuper_en';
import superAdminNavigationEn from '../../_navSuper_es';
import lowAdminNavigationEs from '../../_nav_es';
import lowAdminNavigationEn from '../../_nav_en';
// routes config
import { routesHigh, routesLow, routesSuper } from '../../routes';
import CustomSidebar from './CustomSidebar';
import { fetchOrders, fetchTodayOrders, updateOrderView, updateOrdersView} from '../../store/actions/orderActions';

import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';
import { notificationOptionSetting } from '../../push-notification.js';
import Notification from '../../handlers/Notification';
import { showNotificationForPushEvent, appendNotificationToSidebar } from '../../store/actions/notificationsActions';
import { isUploadingExcel } from '../../store/actions/goodsActions';
import { show as fetchCompany, updateReportHistories, updatePendingActionFromNotification, updateGeneralInvoice } from '../../store/actions/companyActions';
import { updateProviderGeolocation } from '../../store/actions/providerActions';
//import { getStyle } from '@coreui/coreui/dist/js/coreui-utilities';
import { loginBuilder } from '../../config.js';
//import { keyboardHotkeys } from '../../handlers/utils';
import { ADMIN_OWNER, ADMIN_HIGH, ADMIN_LOW, SUPER_ADMIN } from '../../constants/bitwiseOperations';
import { utcDateFormat } from '../../store/actions/UtilsOperation';
import { BRANCH_ACCESS, BRANCH_GROUPS_ACCESS, COMPANY_ACCESS } from '../../constants/general';
import moment from 'moment';
import Breadcrumb from '../../components/Breadcrumb'
import { BranchRequiredRoute } from '../../App'
import { updateBranch, updateProviderOrder } from '../../api/ondemand.js';
import { Debouncer } from '../../utils/debouncer.js';
import { ORDERS_READONLY_TO_ROUTE, getRouteUrl, isOrdersListPath } from '../../utils/permissions';
//import { debug } from 'util';
//const brandPrimary = getStyle('--primary')
class DefaultLayout extends Component {

	constructor(props) {
		super(props);
		this.state = {
			visible: true,
			notification_requirement:true,
			alert_int_service:true
		}
        if (Object.keys(this.props.company).length === 0 && this.props.company.constructor === Object) {
        	this.props.fetchCompany();
        }
		this.sidebarMinimizer = React.createRef();


	}

	async componentDidMount(){
		await socketteInit(this.props.company.id,this.updateFromServerNotification)
		//let retries = localStorage.getItem("pubnubRetries") || 0;

		/*this.pubnub.addListener({
			message: (message) => this.updateFromServerNotification(message.message),
			status: function(statusEvent) {
				if (retries > 3) {
					//this.props.logout();
					return;
				}
				else {
					switch (statusEvent.category) {

						// Conexion estable con Pubnub
						case "PNNetworkUpCategory":
						case "PNReconnectedCategory":
						case "PNConnectedCategory":
							localStorage.setItem("pubnubRetries", 0);
							break;

						// ERROR de conexion con Pubnub
						case "PNAccessDeniedCategory":
							/*Notification.show({
								type: "warning",
								title: "Nuevo inicio sesión detectado",
								msg: "Ha iniciado sesión en otro equipo, por seguridad invalidaremos la sesión en este equipo"
							});* /
							/*setTimeout(function() {
								this.props.logout();
							}.bind(this), 10000);* /
							break;

						case "PNNetworkDownCategory":
						case "PNNetworkIssuesCategory":
						case "PNTimeoutCategory":
						default:
							if (retries === 1){
								Notification.show({
									type: "warning",
									title: "Hubo problemas para conectar",
									msg: "Intentaremos renovar automáticamente. Por favor espere"
								});
							}

							setTimeout(function() {
								localStorage.setItem("pubnubRetries", retries++);
								//forceRenewPubnubToken(this.props.company.id);
								this.pubnub.init(this)
								retries++;
							}.bind(this), 10000);
							break;
					}
				}
			}.bind(this)
		});

		if ( (this.props.session && this.props.session.account_id) && ( this.props.company && this.props.company.id ) ) {
			let allowedChannels = [
				`private-${ this.props.session.account_id }`
			]
			// cuando hay muchos accesos pubnub limita a 200 la cantidad de canales por subscripcion
			let i, j, chunk = 200;

			if( this.props.userHigherAccess === COMPANY_ACCESS ){
				allowedChannels.push(...[
					`group-${ this.props.company.id }-admins`
					//`group-${ this.props.company.id }-tracking`
				])
			}
			else if (this.props.userHigherAccess === BRANCH_GROUPS_ACCESS) {
				this.props.session.accesses.forEach(access => {
					if(access.access_type === "branch"){


						allowedChannels.push(`branch-${ access.access_id }-admins`);
					}
					else if(access.access_type === "branch_group"){
						allowedChannels.push(`branch-group-${ access.access_id }-admins`);
					}
				})
			}
			else if (this.props.userHigherAccess === BRANCH_ACCESS) {
				this.props.session.accesses.forEach(access => {
					if (access.access_type === "branch") {
						allowedChannels.push(`branch-${ access.access_id }-admins`);
					}
				})
			}

			for (i = 0, j = allowedChannels.length; i < j; i += chunk) {
				let _200channels = allowedChannels.slice(i, i + chunk);
				/*this.pubnub.subscribe({
					channels: _200channels
				});* /
			}
		}

		/*var x = document.getElementsByClassName("nav-icon");
		var i;
		for (i = 0; i < x.length; i++) {
		    x[i].style.color = this.props.icon_color;//brandPrimary//
		}*/

		// TODO: activar para las ordenes
		// window.addEventListener("keydown", keyboardHotkeys.bind(this), false);
		ReactDOM.findDOMNode(this.sidebarMinimizer.current).addEventListener('click', this.handleMinimizerToggling.bind(this));
	}

	componentWillUnmount() {
		//window.removeEventListener("keydown", keyboardHotkeys.bind(this), false);
		ReactDOM.findDOMNode(this.sidebarMinimizer.current).removeEventListener('click', this.handleMinimizerToggling.bind(this));
		/*this.pubnub.unsubscribe({
			channels: ["notifications-"+this.props.session.account_id]
		});*/
	}

	debouncer = new Debouncer(5000);

	updateFromServerNotification = async push => {
		let enableNotification = JSON.parse(localStorage.getItem("enableNotification"));
		if (enableNotification === null || enableNotification === undefined){
			enableNotification = true
		}
		// via sockets
		// si el admin tiene perfil tipo "Gerente Comercial" o "Reportes"
		if (this.props.admin_type && (this.props.admin_type.id === 9 || this.props.admin_type.id  === 10) ) return;
		const host_url = window.location.href;
		switch(push.event){
			case "notification":
				let payload = {data: push};
				let notification = {title: "", msg: "", url: "", type: push.action+push.type, storeKey: "", operation: "", update: push.data, touchedPropsToReplace: []};
				let res = await notificationOptionSetting(payload, push.data, notification, this.props.session);
				let PAYLOAD = ((payload && payload.data) || payload);
				const orderFromProviderDetails = this.props.providerOrders;
				if(PAYLOAD.type === 'order_provider'){
					if(orderFromProviderDetails && orderFromProviderDetails.data){
						this.props.updateProviderOrder(PAYLOAD);
					}
				}
				// if(host_url.indexOf("goods-management") !== -1){
				// 	this.props.isUploadingExcel();
				// 	if(push.action==="completed"){
				// 		Notification.show({ type: "success", title:"¡Éxito!", msg:"Carga de documento completada" });
				// 	}
				// }
				if(res){
					notification = { ...res };
					notification.title = `${notification.title} - ${this.props.company.name}`;
					if(host_url.indexOf("order-management") !== -1 || isOrdersListPath(window.location.pathname.split("/")[1])) {
						if(notification.update.id === parseInt(host_url.split("/").pop(),10)){
							this.props.updateOrderView(notification.update);
						}
						// else if(notification.type === "neworder" || notification.type === "assignedorder"){
						else{
							if(PAYLOAD.type === "order"){
								this.props.updateOrdersView(notification.update,notification.type);
							}
							if(PAYLOAD.action === "in_service_changed" && PAYLOAD.type === "branch"){
								this.props.updateBranch(notification.update);
							}
						}
					}
					if (notification.operation === "notification-only"){
						// cuando la notificacion viene de un comercio distinto y soy tipo owner, solo muestrame la notificacion pero no actualices listado de ordenes en el store
						notification.update = null;
					}
					if(PAYLOAD.type === "pending_action"){
						this.props.updatePendingActionFromNotification(notification.update);
					}
				if(enableNotification){
					this.props.appendNotificationToSidebar( notification );
					this.props.showNotificationForPushEvent();
					// this.props.fetchTodayOrders();
					let notificationOptions = {
						type: "push",
						title: notification.title,
						msg: notification.msg,
						url: notification.url,
						sound: notification.sound
					}
					if (notification.sticky) {
						notificationOptions.type = "sticky-push";
						notificationOptions.config = {
							/*autoClose: false*/
							autoClose: 30000
						}
					}
					Notification.show(notificationOptions);
				}
			}
				break;
			case "data_updated":
				/*if(push.type === "provider"){
					let provider_name ="Un proveedor"
					if(this.props.provider.length > 0){
						provider_name = this.props.provider.find(a => parseInt(a.id,10) === push.data.id).name
					}
					let notificationOptions = {
						type: push.action === 'unavailable' ? 'error' : 'success',
						title: this.props.json_lang.common.provider,
						msg: `${provider_name} se ha ${this.props.json_lang.table_admins[`${push.action === 'unavailable' ? 'off_line' : 'online'}`]}`
					}
					Notification.show(notificationOptions);
				}*/

				switch (push.type){
					case "chat_message": 
						const payload = push.data;
						this.props.handleNewMessages(payload, push.action);
						if(push.action === "new"){
							this.props.messageActions(payload.id, "delivered");
						}
						break;
					case "provider":
						if(push.action === "partial_update") {
							this.props.updateProviderGeolocation(push.data);
							localStorage.setItem("providerGeolocationMoved", true);
						}
						break;
					case "report_history":
						this.props.updateReportHistories(push.data);
						break;
					case "general_invoice":
						if(push.action === "new") {
							this.debouncer.delay(() => {
								window.dispatchEvent(new CustomEvent("updateGeneralInvoices", {
									detail: {
										type: "new",
										data: push.data
									}
								}));
							})
						} else if (push.action === "changed") {
							this.props.updateGeneralInvoice(push.data);
						}
						// this.props.updateReportHistories(push.data);
						break;
					default:
						break;
				}
				break;
			default:
				break;
		}

	}

	handleMinimizerToggling(target) {
		// hides the miniture picture of company logo
		// when its clicked it still needs time to end rendering the component with the class to find, thats why I use false if its found
		if (target.currentTarget.id === "sidebar-minimizer")
			if ( !document.getElementsByTagName('sidebar-minimized').length )
				document.getElementById('company-logo-admin').classList.toggle('d-none');
	}

	translatedRoutes = function(routesList) {
		return routesList.map( r => {
			r.name = this.props.json_lang.common[r.lang_key];
			return r;
		},this )
	}

	filterOutMapForNotDeliveryCompanies = (lista) => {
		if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 12 ){
			lista.items.push({
				lang_key: "map",
				name: "Mapa",
				icon: "icon-bag",
				url: "/map",
			})
		}


		//if(parseInt(this.props.defaultDashboard,10)&(512|(512<<12)) !== 0){  // condicion que cumple si es delivery
		if( ( parseInt(this.props.defaultDashboard,10)&(768|(768<<12))) === (768|(768<<12)) ){  // condicion que cumple si es pickup
			return { items: lista.items.filter( elm => elm.lang_key !== "map" ),
				visibles:['map']
			 };
		}
		else
			return {
				...lista,
				visibles:['map','dashboard']
			}
	}

	findUrl(item, filteredList) {
		if (item.url) {
			const splitListUrl = item.url.split('/');
			return splitListUrl[1];
		} else if (item.children && Array.isArray(item.children)) {
			if(filteredList){
				const childUrl = item.children.find(child => filteredList.some(url=> url.url === child.url.split('/')[1]) );
				return childUrl ? childUrl.url.split('/')[1] : null;
			} else {
				const childUrl = item.children.map(child => child.url.split('/')[1]);
				return childUrl;
			}
		}
		return null;
	}

	handleAccesses = (list, type) => {
		const { admin_type } = this.props;

			let data = {};

			if(type === SUPER_ADMIN){
				data = {
					items: [...list.items]
				}
			} else {
				data = {
					items: list.items.map(nav => {
						if (nav.children) {
							let filteredChildren = nav.children.filter(child => child.type < SUPER_ADMIN);
							if (filteredChildren.length > 0) {
								return { ...nav, children: filteredChildren };
							}
						} else if (nav.type < SUPER_ADMIN) {
							return nav;
						}
					}).filter(nav => nav !== undefined)
				};
			}

			let visibles = null;

			if(admin_type){

				let filteredRoles = [];

				if(admin_type.roles.length !== 0){
					filteredRoles = admin_type.roles.filter(role => role.role.startsWith('access'));
				}
				// TODO borrar cuando no sea necesaria esta condicion
				if(filteredRoles.length === 0){
					let data = { items: list.items.filter( elm => ( (elm.lang_key !== "categories") &&
						(elm.lang_key !== "company_settings") &&
						(elm.lang_key !== "attributes") &&
						(elm.lang_key !== "goods") &&
						(elm.lang_key !== "eta") &&
						(elm.lang_key !== 'Branch dashboard') ) ) };

					let visibles =[]
					if(this.props.branch && this.props.branch.id){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== "company_settings") /*&& (elm.lang_key !== 'Branch dashboard')*/ ) ) };
						visibles =['','company_settings'];
					}

					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 3 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== "providers") &&
							(elm.lang_key !== 'promo') && (elm.lang_key !== 'coupons') &&
							(elm.lang_key !== 'push_notification') && (elm.lang_key !== 'banners')  &&
							(elm.lang_key !== "branchs") && (elm.lang_key !== "admins") &&
							(elm.lang_key !== "company") && (elm.lang_key !== "map") &&
							/*(elm.lang_key !== "dashboard") &&*/ (elm.lang_key !== "settings") &&
							(elm.lang_key !== "categories") && (elm.lang_key !== "company_settings") &&
							(elm.lang_key !== "attributes") && (elm.lang_key !== "goods") &&
							(elm.lang_key !== "featured_products") &&
							(elm.lang_key !== "section") &&
							(elm.lang_key !== "eta") &&
							(elm.lang_key !== "branches") &&
							(elm.url !== "/company-billings") && // importante
							(elm.lang_key !== "reports") &&

							//(elm.lang_key !== "billing") &&
							(elm.lang_key !== 'Branch dashboard') && (elm.lang_key !== "clients") ) ) };
						visibles =['','providers','promo','coupons','push_notification','banners',"branchs","admins","categories","company_settings","attributes","goods","featured_products","section","eta","branches","reports"];
					}

					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 4 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== "branchs") &&
							(elm.lang_key !== 'promo') && (elm.lang_key !== 'coupons') &&
							(elm.lang_key !== 'push_notification') && (elm.lang_key !== 'banners') &&
							(elm.lang_key !== "admins") && (elm.lang_key !== "company") &&
							(elm.lang_key !== "dashboard") && (elm.lang_key !== "billing") &&
							(elm.lang_key !== "settings") && (elm.lang_key !== "categories") &&
							(elm.lang_key !== "company_settings") && (elm.lang_key !== "attributes") &&
							(elm.lang_key !== "goods") && (elm.lang_key !== 'Branch dashboard') &&
							(elm.lang_key !== "clients") ) ) };
					}

					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 5 ){
						data = { items: list.items.filter( elm => ((elm.lang_key !== "billing") && (elm.lang_key !== 'Branch dashboard') && (elm.lang_key !== 'dashboard') ) ) };

						if( !(this.props.branch && this.props.branch.id) ){
							data = {
								items: list.items.filter( elm => (
									(elm.lang_key !== "attributes") && (elm.lang_key !== "goods") &&
									(elm.lang_key !== "categories") && (elm.lang_key !== "billing") &&
									(elm.lang_key !== "clients") &&
									//(elm.lang_key !== 'company') &&
									//(elm.lang_key !== "branchs") &&
									(elm.lang_key !== 'Branch dashboard') && (elm.lang_key !== 'dashboard')  )
								)
							};
						}
						visibles =['',"categories","goods","attributes","eta","branches","Roles","admins","providers","Notificaciones masivas","section","promo","branchs-groups","banners","coupons","featured-products","notifications"];

					}

					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 6 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== 'promo') &&
							(elm.lang_key !== "billing") && (elm.lang_key !== 'reports') &&
							(elm.lang_key !== 'coupons') && (elm.lang_key !== 'push_notification') &&
							(elm.lang_key !== 'banners')  && (elm.lang_key !== "branchs") &&
							(elm.lang_key !== "admins") && (elm.lang_key !== "company") &&
							(elm.lang_key !== "map") && (elm.lang_key !== "dashboard") &&
							(elm.lang_key !== "settings") && (elm.lang_key !== "categories") &&
							(elm.lang_key !== "company_settings") && (elm.lang_key !== "attributes") &&
							(elm.lang_key !== "goods") && (elm.lang_key !== 'Branch dashboard') && (elm.lang_key !== "clients") ) ) };
					}
					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 7 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== 'promo') && (elm.lang_key !== "billing") &&
							(elm.lang_key !== 'coupons') && (elm.lang_key !== 'push_notification') &&
							(elm.lang_key !== 'banners')  && (elm.lang_key !== "branchs") &&
							(elm.lang_key !== "admins") && (elm.lang_key !== "company") &&
							(elm.lang_key !== "settings") && (elm.lang_key !== "categories") &&
							(elm.lang_key !== "company_settings") && (elm.lang_key !== "attributes") &&
							(elm.lang_key !== "goods") && (elm.lang_key !== 'Branch dashboard') &&
							(elm.lang_key !== "clients") ) ) };
					}
					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 8 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== 'promo') && (elm.lang_key !== 'map') &&
							(elm.lang_key !== 'providers')  && (elm.lang_key !== 'dashboard') &&
							(elm.lang_key !== "billing") && (elm.lang_key !== 'coupons') &&
							(elm.lang_key !== 'push_notification') && (elm.lang_key !== 'banners') &&
							(elm.lang_key !== "branchs") && (elm.lang_key !== "admins") &&
							(elm.lang_key !== "company") && (elm.lang_key !== "settings") &&
							(elm.lang_key !== "categories") && (elm.lang_key !== "company_settings") &&
							(elm.lang_key !== "attributes") && (elm.lang_key !== "goods") &&
							(elm.lang_key !== 'Branch dashboard') && (elm.lang_key !== "clients") ) ) };
					}
					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 9 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== 'orders') && (elm.lang_key !== 'promo') &&
							(elm.lang_key !== 'map') && (elm.lang_key !== 'providers') &&
							(elm.lang_key !== "billing") && (elm.lang_key !== 'coupons') &&
							(elm.lang_key !== 'push_notification') && (elm.lang_key !== 'banners') &&
							(elm.lang_key !== "branchs") && (elm.lang_key !== "admins") &&
							(elm.lang_key !== "company") && (elm.lang_key !== "settings") &&
							(elm.lang_key !== "categories") && (elm.lang_key !== "company_settings") &&
							(elm.lang_key !== "attributes") && (elm.lang_key !== "goods") &&
							(elm.lang_key !== 'Branch dashboard') && (elm.lang_key !== "clients") ) ) };
					}

					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 10 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== 'dashboard') && (elm.lang_key !== 'orders') &&
							(elm.lang_key !== 'promo') && (elm.lang_key !== 'map') &&
							(elm.lang_key !== 'providers') && (elm.lang_key !== "billing") &&
							(elm.lang_key !== 'coupons') && (elm.lang_key !== 'push_notification') &&
							(elm.lang_key !== 'banners')  && (elm.lang_key !== "branchs") &&
							(elm.lang_key !== "admins") && (elm.lang_key !== "company") &&
							(elm.lang_key !== "settings") && (elm.lang_key !== "categories") &&
							(elm.lang_key !== "company_settings") && (elm.lang_key !== "attributes") &&
							(elm.lang_key !== "goods") && (elm.lang_key !== 'Branch dashboard') &&
							(elm.lang_key !== "clients") ) ) };
					}

					if( this.props.session && this.props.session.admin_type && this.props.session.admin_type.id === 12 ){
						data = { items: list.items.filter( elm => ( (elm.lang_key !== "providers") &&
							(elm.lang_key !== 'promo') && (elm.lang_key !== 'coupons') &&
							(elm.lang_key !== 'push_notification') && (elm.lang_key !== 'banners')  &&
							(elm.lang_key !== "branchs") && (elm.lang_key !== "admins") &&
							(elm.lang_key !== "company") && (elm.lang_key !== "settings") &&
							(elm.lang_key !== "categories") && (elm.lang_key !== "company_settings") &&
							(elm.lang_key !== "attributes") && (elm.lang_key !== "goods") &&
							(elm.lang_key !== "featured_products") &&
							(elm.lang_key !== "section") &&
							(elm.lang_key !== "eta") &&
							(elm.lang_key !== "branches") &&
							(elm.url !== "/company-billings") &&
							(elm.lang_key !== "reports") &&
							(elm.lang_key !== 'Branch dashboard') && (elm.lang_key !== "clients") ) ) };

						visibles =["","map","coupons","promo","branchs","attributes","goods","branches"];
					}

					if(this.props.isZupper){
						data = { items: list.items.filter( elm => ( elm.lang_key !== 'branches') && (elm.lang_key !== 'Branch dashboard')) };

					}

					return  {
						...data,
						visibles:this.props.session && this.props.session.admin_type && this.props.session.admin_type.id ? visibles : null
					}
				}
				const filteredList = filteredRoles.map(role => {
					const splitUrl = role.role.split('_');
					return ({ url: splitUrl[1] })
				});

				// El permiso "Configuración de comercio" (access_branch-settings) también debe
				// permitir el acceso a la sección de Configuración (/settings), igual que access_settings.
				if (
					filteredRoles.some(role => role.role === 'access_branch-settings') &&
					!filteredList.some(item => item.url === 'settings')
				) {
					filteredList.push({ url: 'settings' });
				}

				// Los permisos de "solo visualización" de cada vista de órdenes (ej: access_orders-ro-unpaid)
				// también deben permitir el acceso a la ruta de su vista (ej: /orders-unpaid),
				// igual que su par de acceso completo.
				Object.keys(ORDERS_READONLY_TO_ROUTE).forEach(readonlyUrl => {
					const routeUrl = ORDERS_READONLY_TO_ROUTE[readonlyUrl];
					if (
						filteredRoles.some(role => role.role === `access_${readonlyUrl}`) &&
						!filteredList.some(item => item.url === routeUrl)
					) {
						filteredList.push({ url: routeUrl });
					}
				});

				data = {
					items: data.items.filter(item => {
						const urlToCheck = this.findUrl(item, filteredList);
						return filteredList.some(filtered => filtered.url === urlToCheck);
					})
				}
				data.items.map((item, index) =>{
					if(item.children){
						const newChildData = item.children.filter(child => {
							const splitChildUrl = child.url.split('/')[1];
							return filteredList.some(filtered => filtered.url === splitChildUrl);
						})
						data.items[index] = {
							...item,
							children: newChildData
						}
					}
				});
			} else if (type !== SUPER_ADMIN) {
				data.items = data.items.filter((item) => item.lang_key !== "webhooks" && item.lang_key !== "api_partners")
			}
			return  {
				...data,
				visibles: visibles
			}

	}

	handleCloseCustomSidebar(){
		if(document.body.classList.contains('sidebar-show')){
			document.body.classList.remove('sidebar-show');
		}
	}

	render() {
		if (!this.props.session){
			this.props.history.push('/login');
		}
		var routes, adminNavigation, hasEnglishEnabled = (this.props.lang_code && this.props.lang_code === 'en');

		const navList = hasEnglishEnabled ? highAdminNavigationEn : highAdminNavigationEs;

		switch(this.props.session && this.props.session.account && this.props.session.account.type){


			case ADMIN_LOW:
				routes = routesHigh;
				adminNavigation = this.handleAccesses(navList, ADMIN_LOW);
				break;

			case ADMIN_HIGH:
				routes = routesHigh;
				adminNavigation = this.handleAccesses(navList, ADMIN_HIGH);
				break;

			case ADMIN_OWNER:
				routes = routesHigh;
				adminNavigation = this.handleAccesses(navList, ADMIN_OWNER);
				break;
			case SUPER_ADMIN:
				routes = routesHigh;
				adminNavigation = this.handleAccesses(navList, SUPER_ADMIN);
				break;

			default:
				routes = routesLow;
				adminNavigation = this.filterOutMapForNotDeliveryCompanies( hasEnglishEnabled ? lowAdminNavigationEn : lowAdminNavigationEs);
				break;
		}
		const transRoutes = this.translatedRoutes(routes);
		var now = utcDateFormat(undefined,"YYYY/MM/DD");
		var trial_date = 0;
		var subscription = "";
		var endDate =0;
		if(this.props.company && this.props.company.custom_json && this.props.company.custom_json.subscription && this.props.company.custom_json.subscription.current_period_end){
			subscription = this.props.company && this.props.company.custom_json && this.props.company.custom_json.subscription;
			trial_date = moment( utcDateFormat(subscription.current_period_end,"YYYY/MM/DD") )
			endDate=trial_date.diff(now,"days")
		}

		let logo_link = '/dashboard'

		if(this.props.session.admin_type){
			const adminType = this.props.session.admin_type;
			let filteredUrl = [];

			if(this.props.branch && this.props.branch.id){
				adminNavigation.items.map(nav => {
					filteredUrl = [...filteredUrl, this.findUrl(nav)]
				})
			}else{
				adminNavigation.items.filter(filter => filter.lang_key !== "inventory").map(nav => {
					filteredUrl = [...filteredUrl, this.findUrl(nav)]
				})
			}

			// admin_types guardados con una llave de solo visualización como vista por defecto
			// (ej: orders-readonly) deben caer en la ruta de su vista.
			const defaultKey = getRouteUrl(adminType.default_key);

			const findUrl = filteredUrl.find(url=> {
				if(Array.isArray(url)){
					return url.some(someUrl => someUrl === defaultKey)
				}else{
					return url === defaultKey
				}
			})

			if(findUrl){
				logo_link = `/${defaultKey}`
			}else{
				if(Array.isArray(filteredUrl[0])){
					logo_link = `/${filteredUrl[0][0]}`
				}else{
					logo_link = `/${filteredUrl[0]}`
				}
			}
		}

		return <div className="app">
			<AppHeader fixed>
				<DefaultHeader handleCloseCustomSidebar = {this.handleCloseCustomSidebar} logoLink = {logo_link} />
			</AppHeader>
			{/*<GeneralErrors>*/}
				<div className="app-body">

					{ /* left sidebar */ }
					<AppSidebar fixed display = "lg" >
						<AppSidebarHeader />
						<AppSidebarForm />
						<CustomSidebar navConfig={ adminNavigation } {...this.props} />
						<AppSidebarFooter />
						<AppSidebarMinimizer id="sidebar-minimizer" ref={this.sidebarMinimizer} />
					</AppSidebar>

					<main className="main" onClick={() => this.handleCloseCustomSidebar()}>
						<div id="two-steps-verification" />
						{
							this.state.alert_int_service === true && this.props.company && this.props.company.in_service === false && !this.props.company.in_service2?
								<Alert color="warning m-0 text-center">
									{this.props.json_lang.common.alert_int_service}
									{/*<span className={ 'hidden_icon' } onClick={ ()=> this.setState({alert_int_service:false}) }>
								    	<i className={ 'icon-close' }></i>
								    </span>*/}
								</Alert>
							:
							null
						}

						{
							this.props.company && this.props.company.phone && this.props.company.phone=== null ?
							<Alert color = "warning m-0 text-center" >
								{this.props.json_lang.common.alert_no_phone_company}
							</Alert>
							:null
						}


						{
							subscription && subscription.status === 'trialing' ?
							<Alert color={ endDate < 0 ? "danger" : "info" } className={ 'm-0 text-center' }>
								{
									endDate < 0 ?
									<Fragment>
										<b>{`${this.props.json_lang.common.trial.toUpperCase()} ${this.props.json_lang.common.expired}`}</b>
										, {this.props.json_lang.common.trial_description_fail.toLowerCase()}
										<a href={`${loginBuilder}login?user=${this.props.session.email}`} target="_blank" className={'ml-2'}>
									    	{this.props.json_lang.common.verify}
									    </a>
									</Fragment>
									:
									<Fragment>
										{
											endDate === 0 ?
											<b>{`${this.props.json_lang.common.trial.toUpperCase()} disponible hasta hoy`}</b>
											:
											<b>{`${this.props.json_lang.common.trial.toUpperCase()} ${this.props.json_lang.common.available_by.toLowerCase()} ${endDate} ${this.props.json_lang.common.days.toLowerCase()}`}</b>
										}
										, {this.props.json_lang.common.trial_description.toLowerCase()}
										<a href={`${loginBuilder}login?user=${this.props.session.email}`} target="_blank" className={'btn btn-success btn-large ml-2'}>
											{this.props.json_lang.common.ativate_now}
										</a>
									</Fragment>
								}
							</Alert>
							:
							null
						}



						{
							(this.props.location.pathname === '/map' || this.props.location.pathname === '/dashboard') /*|| (this.props.admin_type && (
							this.props.admin_type.id === 10 || this.props.admin_type.id === 3 || this.props.admin_type.id === 2 || this.props.admin_type.id === 1 ||
							this.props.admin_type.id === 10 || this.props.admin_type.id === 3 || this.props.admin_type.id === 2 || this.props.admin_type.id === 1 ||
							this.props.admin_type.id === 4 || this.props.admin_type.id === 6 || this.props.admin_type.id === 8 || this.props.admin_type.id === 9 ||
							this.props.admin_type.id === 7 ))*/?
								null
							: (
								// <AppBreadcrumb appRoutes={transRoutes}/>
								<Breadcrumb routes={transRoutes} session={this.props.session} />
							)
						}
						<Fragment>
							<Switch>
								{
									routes.map((route, key) => {
										return route.component ?
											route.requiresAdmin && !this.props.session.is_admin ?
												<Redirect key={ key } from="/" to={ logo_link } />
											:
											<Route key={ key } path={ route.path } exact={ route.exact } name={ route.name } render={ (props) => {

												if (route.branchRequired) return <BranchRequiredRoute component={route.component} />

												return (
													<route.component {...props} title={ route.name } />
												)
											}} />
										: (null)
									})
								}
								<Redirect from="/" to={ logo_link } />
							</Switch>
						</Fragment>
					</main>

					{ /* toggleable right sidebar */ }
					<AppAside fixed style={{ overflowY: "auto" }}>
						<DefaultAside />
					</AppAside>
				</div>
				<AppFooter>
					{
						process.env.REACT_APP_ENV.toUpperCase() !== 'PRODUCTION'
						? <span className="env-warning">{process.env.REACT_APP_ENV} </span>
						: null
					}
					<DefaultFooter />
				</AppFooter>
			{/*</GeneralErrors>*/}
		</div>
	}
}

const mapStateToProps = (state) => {
	let zupper = false;
	if(state.company){
		if(state.company.id === 7  || state.company.id === 120){
			zupper = true
		}
	}
	return {
		isZupper:zupper,
		company: state.company,
		session: state.session,
		errors: state.errors,
		user: state.user,
		//providers: state.providers,
		provider: state.providers,
		mapFilters: state.mapFilters,
		notificationPushEvent: state.notificationPushEvent,
		notifications: state.notifications,
		defaultDashboard:state.company.options,
		lang_code: state.lang_code,
		json_lang: state.json_lang,
		icon_color:state.company_styles_json.color_accent,
		userHigherAccess:state.userHigherAccess,
		branch:state.branch,
		admin_type:state.session && state.session.admin_type,
		admin_account_type:state.session && state.session.account && state.session.account.type,
		showNotification:state.showNotification,
		providerOrders: state.providerOrders
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		logout: () => dispatch(logout()),
		updateOrderView: (order) => dispatch(updateOrderView(order)),
		updateOrdersView: (new_order,type) => dispatch(updateOrdersView(new_order,type)),
		showNotificationForPushEvent: () => dispatch(showNotificationForPushEvent()),
		appendNotificationToSidebar: (notification) => dispatch(appendNotificationToSidebar(notification)),
		fetchCompany: () => dispatch(fetchCompany()),
		updateProviderGeolocation: (newData) => dispatch(updateProviderGeolocation(newData)),
		isUploadingExcel: () => dispatch(isUploadingExcel()),
		fetchOrders: () => dispatch(fetchOrders()),
		fetchTodayOrders: () => dispatch(fetchTodayOrders()),
		updateProviderOrder: (order, type) => dispatch(updateProviderOrder(order, type)),
		updateReportHistories: (payload) => dispatch(updateReportHistories(payload)),
		handleNewMessages: (payload, push) => dispatch(handleNewMessages(payload, push)),
		messageActions: (messageId, action) => dispatch(messageActions(messageId, action)),
		updatePendingActionFromNotification: (pendingAction) => dispatch(updatePendingActionFromNotification(pendingAction)),
		updateBranch: (branch) => dispatch(updateBranch(branch)),
		updateGeneralInvoice: (payload) => dispatch(updateGeneralInvoice(payload)),
	}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DefaultLayout));



// WEBPACK FOOTER //
// ./src/containers/DefaultLayout/DefaultLayout.js